import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SupplierForm = forwardRef((props, ref) => {
    const [supplierModal, setSupplierModal] = useState(false);
    
    const [formData, setFormData] = useState([])

    const [errors, setErrors] = useState(null); // Handling errors
    useEffect(() => {
        if (props.data) {
          setFormData(props.data);
          console.log(props.data)
        }
      }, [props.data]);
    
 
    // Handle form field change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            // Send POST request to the API
            const phone = formData.Phone ? String(formData.Phone) : ''; 

        if (!phone.match(/^(218)?09[123456][0-9]{7}$/)) {
            setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092');
            console.log(errors);
        }
        else{
            axios.put(`https://subk.education.com.ly/back/api/suppliers/${formData.SupplierID}`, formData)
            .then(() => {
                setFormData('')
                props.parentFunction()
            setErrors('')  
            setFormData('')
            toast.success('تم حفظ  التعديل  بنجاح!');
            setSupplierModal(false)
            })
       }  } catch (error) {
            console.error('There was an error submitting the form!', error);
            setErrors('Failed to submit supplier data.');
        }
    };

    useImperativeHandle(ref, () => ({
        showSupplierModal() {
            setSupplierModal(true);
        },
    }));
    useEffect(() => {
        const handleEnterKey = (e) => {
        if (e.key === 'Enter') {
        e.preventDefault();
        const form = e.target.form;
        const fields = Array.from(form.elements).filter(el => (
          (el.tagName === 'INPUT' && !el.disabled) ||
          (el.tagName === 'TEXTAREA' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled)
        ));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
        const nextFieldIndex = currentFieldIndex + 1;
        if (nextFieldIndex < fields.length) {
          fields[nextFieldIndex].focus();
        }
        }
        };
        
        document.addEventListener('keydown', handleEnterKey);
        
        return () => {
        document.removeEventListener('keydown', handleEnterKey);
        };
        }, []);
    return (
        <>
                    <ToastContainer />

      
        <Modal className="modal fade" size="lg" show={supplierModal} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">تفاصيل المورد</h1>
                     <button type="button" style={{ marginLeft: 0 }} className="btn-close" onClick={() => setSupplierModal(false)}></button>

                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xl-12">
                                {errors && <div className="alert alert-danger">{errors}</div>}
                            </div>
                            
                            <div className="col-xl-6">
                                <label className="form-label mt-3">اسم المورد <span className="text-danger">*</span></label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="SupplierName"
                                    value={formData.SupplierName}
                                    onChange={handleChange}
                                    required
                                     pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                />
                            </div>

                            <div className="col-xl-6">
                                <label className="form-label mt-3">رقم الهاتف<span className="text-danger">*</span></label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="Phone"
                                    value={formData.Phone}
                                    onChange={handleChange}
                                     
                                />
                            </div>

                            <div className="col-xl-6">
                                <label className="form-label mt-3">البريد الالكتروني<span className="text-danger">*</span></label>
                                <input
                                    className="form-control"
                                    type="email"
                                    name="Email"
                                    value={formData.Email}
                                    onChange={handleChange}
                                     
                                />
                            </div>

                            <div className="col-xl-6">
                                <label className="form-label mt-3">العنوان</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="Address"
                                    value={formData.Address}
                                    onChange={handleChange}
                                />
                            </div>

                            
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">حفظ</button>
                        <button
                            type="button"
                            className="btn btn-danger light"
                            onClick={() => setSupplierModal(false)}
                        >
                            الغاء
                        </button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </Modal>  </>
    );
});

export default SupplierForm;
